import { render, staticRenderFns } from "./MbInfo.vue?vue&type=template&id=302949b6&"
import script from "./MbInfo.vue?vue&type=script&lang=js&"
export * from "./MbInfo.vue?vue&type=script&lang=js&"
import style0 from "./MbInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports